'use client';

import type { Panel } from "@/app/config/form-config";
import { InteractiveForm } from "./InteractiveForm";

interface InteractiveFormWrapperProps {
  serverLocationHeadline?: string | undefined;
  schoolDistrictDiscounts?: { [districtId: string]: number };
  customFormConfig?: {
    panels?: string[];
    order?: string[];
  };
  resolvedPanels: Panel[];
  redirectUrl?: string;
  subject?: string | null;
  type?: string | null;
  location?: string | null;
  headlineOverride?: string | null;
  firstQuestionOverride?: string | null;
  assumedGradeLevel?: string | null;
  prefilledZipCode?: string | null;
  districtNameOverride?: string | null;
  discountOverride?: string | null;
  applicationId?: string;
}

export function InteractiveFormWrapper({ serverLocationHeadline, schoolDistrictDiscounts, customFormConfig, resolvedPanels, redirectUrl, subject, type, location, headlineOverride, firstQuestionOverride, assumedGradeLevel, prefilledZipCode, districtNameOverride, discountOverride, applicationId }: InteractiveFormWrapperProps) {
  return (
    <InteractiveForm
      serverLocationHeadline={serverLocationHeadline}
      schoolDistrictDiscounts={schoolDistrictDiscounts}
      customFormConfig={customFormConfig}
      resolvedPanels={resolvedPanels}
      redirectUrl={redirectUrl}
      subject={subject}
      type={type}
      location={location}
      headlineOverride={headlineOverride ?? undefined}
      firstQuestionOverride={firstQuestionOverride ?? undefined}
      assumedGradeLevel={assumedGradeLevel ?? undefined}
      prefilledZipCode={prefilledZipCode ?? undefined}
      districtNameOverride={districtNameOverride ?? undefined}
      discountOverride={discountOverride ?? undefined}
      applicationId={applicationId}
    />
  );
}
